import { useEffect, useRef } from 'react';

import { useSlate } from 'slate-react';

export default function useToolbarVM() {
  const editor = useSlate();
  const editorRef = useRef(editor);

  useEffect(() => {
    editorRef.current = editor;
  }, [editor]);

  return {
    editorRef,
  };
}
